module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('stepTitle', {
    attrs: {
      "navItems": ['LiveVR Classroom'],
      "index": 1,
      "step": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container my-4 px-0 py-5",
    staticStyle: {
      "background": "#fff",
      "min-height": "80vh"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21360a44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/vr/VRLayout.vue
// module id = 760
// module chunks = 3